var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position--relative"},[_c('horizontal-type-d',{staticClass:"spacing--lg"}),_vm._t("default"),_c('footer-type-a')],2)}
var staticRenderFns = []

export { render, staticRenderFns }